<template>
  <div class="th-dropdown-container">
    <div class="flex justify-between items-center">
      <div class="title-content">{{title}}</div>
      <div class="additional">
        <div class="title-extra" v-if="extraTitle">{{extraTitle}}</div>
        <div class="flex justify-center items-center th-hover-pointer" @click.prevent="actionCollapse" :class="!isExpanded ? 'th-rotate-180' : null"><arrow-up-icon @click.prevent="actionCollapse" /></div>
      </div>
    </div>
    <slot v-if="isExpanded"></slot>
  </div>
</template>

<script>
const ArrowUpIcon = () => import('@/components/Icon/ArrowUp.vue')
export default {
  props: {
    title: { type: String },
    extraTitle: { type: String },
  },
  data() {
    return {
      isExpanded: true,
    }
  },
  components: {
    ArrowUpIcon,
  },
  methods: {
    actionCollapse() {
      console.log('masuk')
      this.isExpanded = !this.isExpanded
    },
  },
}
</script>

<style lang="scss">
.th-dropdown-container {
  .title-content, .title-extra {
    font-weight: 600;
  }

  .title-content {
    font-size: 16px;
  }

  .title-extra {
    font-size: 14px;
    margin-right: 25px;
  }

  .additional {
    display: flex;
  }
}
</style>
